// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7d46e35","455":"3ce29524"}[chunkId] + ".chunk.js";
};